// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__bE0nC","checkboxCol":"Table_checkboxCol__cAh3G","emailCol":"Table_emailCol__pBjrm","actionCol":"Table_actionCol__WPT19"};